import { Add, Close } from '@mui/icons-material';
import { Box, Button, Dialog, Divider, Grid, IconButton, Typography } from '@mui/material';
import React, { Component } from 'react';
import BlastSetup from './Blastsetup';
class BlastTelemarketing extends Component {
    state = { 
        showBlastSetup: false
    } 

    handleCloseBlastSetup = () => {
        this.setState({showBlastSetup: false});
    }

    handleShowBlastSetup = () => {
        this.setState({showBlastSetup: true});
    }

    render() { 
        return (
            <Box sx={{p: "20px"}}>
                <Box>
                    <Grid container spacing={1}>
                        <Grid item xs={9}>
                            <Typography variant='h5'>Blast Telemarketing</Typography>
                        </Grid>
                        <Grid item xs={2} sx={{textAlign: "right"}}>
                            <Button 
                                color='primary' 
                                size='small' 
                                variant='outlined' 
                                sx={{textTransform: "capitalize"}}
                                onClick={this.handleShowBlastSetup}
                            >
                                <Add />&nbsp;Tambah Blast
                            </Button>
                        </Grid>
                        <Grid item xs={1} sx={{textAlign: "right"}}>
                            <IconButton color='error'><Close /></IconButton>
                        </Grid>
                    </Grid> 
                </Box>
                <Divider />
                <Box>

                </Box>

                <Dialog
                    open={this.state.showBlastSetup}
                    onClose={this.handleCloseBlastSetup}
                    maxWidth={"xl"}
                    fullWidth
                >
                    <BlastSetup data={this.state} onClose={this.handleCloseBlastSetup}/>
                </Dialog>
            </Box>
        );
    }
}
 
export default BlastTelemarketing;